<form [formGroup]="currentForm">
    <ng-container *ngIf="(proposalService.calculatedPremiums$ | async) as calculatedPermiums;">
        <div class="wrapper-panel-component margin-box" nxRow style="margin-bottom: 20px;">
            <div nxCol="12">
                <h2 class="align-center">{{data['heading'] | translate}}</h2>
            </div>
            <div *ngIf="parentForm.controls.propertyCategory.value === '1' || parentForm.controls.propertyCategory.value === '3'"
                 nxCol="12">

                <nx-formfield [ngClass]="{'has-error': parentForm.controls.immovableinsuranceSumRecommended?.errors?.invalid}"
                              [label]="data.immovable | translate">
                    <input
                            formControlName="immovableinsuranceSumRecommended"
                            mask="separator.2"
                            nxInput
                            (change)="this.trackService.checkErrors( parentForm.controls.immovableinsuranceSumRecommended, 'Recommended sum')" >
                    <span nxFormfieldHint>{{ data.immovableLimit | translate:{value: calculatedPermiums.immovableinsuranceSum  | mask: 'separator.2'} }} {{(sharedService.getCurrency() | async).main | translate}} </span>
                    <span>{{(sharedService.getCurrency() | async).main | translate}}</span>
                </nx-formfield>
                <nx-message-banner *ngIf="currentForm.controls.immovableinsuranceSumRecommended?.errors?.invalid"
                                   appCloseBanner="immovableinsuranceSumRecommended" closeButtonLabel="error.close | translate" context="error" 
                                   nxFormfieldError>
                    {{currentForm.controls.immovableinsuranceSumRecommended?.errors?.invalid}}
                </nx-message-banner>
            </div>
            <div *ngIf="parentForm.controls.propertyCategory.value === '2' || parentForm.controls.propertyCategory.value === '1'"
                 nxCol="12">

                <nx-formfield class="nx-margin-top-3m" [ngClass]="{'has-error': currentForm.controls.movableinsuranceSumRecommended?.errors?.invalid}"
                              [label]="data.movable | translate">
                    <input formControlName="movableinsuranceSumRecommended"
                           mask="separator.2"
                           nxInput
                           (change)="this.trackService.checkErrors( parentForm.controls.immovableinsuranceSumRecommended, 'Recommended sum')">
                    <!-- <span *ngIf="parentForm.controls.propertyCategory.value === '1'" nxFormfieldHint>{{'details2.movableLimit' | translate: {
                        minValue: movableinsuranceSum  | mask: 'separator.2',
                        maxValue: movableinsuranceSumRecommended  | mask: 'separator.2'
                        } }} {{(sharedService.getCurrency() | async).main | translate}} </span> -->

                         <span *ngIf="parentForm.controls.propertyCategory.value === '1'" nxFormfieldHint>
                        {{movableinsuranceSum  | mask: 'separator.2' }} {{(sharedService.getCurrency() | async).main | translate}} - 
                        {{movableinsuranceSumRecommended  | mask: 'separator.2' }}
                        {{(sharedService.getCurrency() | async).main | translate}}
                         </span>

                    <span *ngIf="parentForm.controls.propertyCategory.value === '2'" nxFormfieldHint>{{'details2.movableLimitSingle' | translate: {
                        minValue: movableinsuranceSum  | mask: 'separator.2'
                        } }} {{(sharedService.getCurrency() | async).main | translate}}</span>
                    <span>{{(sharedService.getCurrency() | async).main | translate}}</span>
                </nx-formfield>
                <nx-message-banner *ngIf="currentForm.controls.movableinsuranceSumRecommended?.errors?.invalid"
                                   appCloseBanner="movableinsuranceSum" closeButtonLabel="error.close | translate" context="error"
                                   nxFormfieldError>
                    {{currentForm.controls.movableinsuranceSumRecommended?.errors?.invalid}}
                </nx-message-banner>
            </div>
            <div align="center" class="nx-margin-top-m" nxCol="12">
                <qbe-button (click)="updateInsSums()" [disabled]="isLoading || !currentForm.valid"
                            [mode]="'primary'">
                    {{ data.btnOkText | translate}}
                </qbe-button>
            </div>
        </div>
    </ng-container>
</form>
